import {connect} from 'react-redux'
import {compose, withHandlers} from 'recompose'
import {selectCompositeByIdFromUrl} from '../../../redux/selectors/selectors'
import CountSetter from '../components/CountSetter'
import {processServingsChange} from '../epics/epics'

const mapStateToProps = (state) => {
  const composite = selectCompositeByIdFromUrl(state)
  return {
    composite,
    count: composite && composite.servings,
    descriptionTranslateKey: 'portions',
  }
}

const mapDispatchToProps = {
  processServingsChange,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onMinusClick:
      ({composite, processServingsChange}) =>
      () => {
        processServingsChange({composite, type: 'decrease'})
      },
    onPlusClick:
      ({composite, processServingsChange}) =>
      () => {
        processServingsChange({composite, type: 'increase'})
      },
    onChange:
      ({composite, processServingsChange}) =>
      (value) => {
        processServingsChange({composite, type: 'update', value})
      },
  }),
)(CountSetter)
